module.exports = __webpack_public_path__ + "static/9-9a2c3aaab10e727cd3d6fb28c061ee8e.jpg";